// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"7470195d54c55ce15306","147":"937f8c895beb966ed592","251":"f3215b68ddb688d0d1e8","352":"30d0a3c908647f750646","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};